export default "__VITE_ASSET__6Pve5_n4__"